// PRD 20 §3.3.4 — phone storage/display format is 010-XXXX-XXXX. Helpers below
// keep the FE in sync with that contract and isolate the digit-only model used
// during input from the formatted display.

import { PHONE_REGEX } from '@/shared/utils/phone';

const DIGITS_REGEX = /\D/g;

export function digitsOnly(value: string): string {
  return (value ?? '').replace(DIGITS_REGEX, '');
}

// Valid only for the canonical 11-digit '010'-prefixed number (PRD 20 v1.1 /
// PRD 21 §3.3.1: `^010\d{8}$`). 10-digit / non-'010' inputs are rejected so
// [인증번호 받기] stays disabled until length is exactly 11 (SHCT-327).
export function isValidPhoneDigits(digits: string): boolean {
  return PHONE_REGEX.test(digits);
}

// PRD 20 §3.3 — saved format is 010-XXXX-XXXX (11 digits) or 010-XXX-XXXX (10 digits).
export function formatPhone(digits: string): string {
  if (digits.length === 11) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return digits;
}
